export const BASE_URL = process.env.REACT_APP_API_URL!;

export const ADMIN_AUTH_URL = `${BASE_URL}/admin/auth`;
